import { Exclude, Expose, Type } from 'class-transformer';

import { SnCollection, SnModel } from '@lib/common/models';

import { SnContentType } from '../base';
import { SnOrganization } from '../organization';
import { SnShareInfo } from '../share';
import { SnLayerObject } from './layer-feature';
import { SnLayerHit } from './layer-hit';
import { SnLayerMeta } from './layer-meta';

export class SnBaseLayer extends SnModel {
  public readonly contentType = SnContentType.Layer;

  @Expose()
  public id: string;

  @Expose()
  public name: string;

  @Expose()
  public icon: string;

  @Expose()
  public fontSet: string;

  @Expose()
  public imageUrl: string;

  @Expose()
  public color: string;

  @Expose()
  public scale: number;

  @Expose()
  public isDefaultCad: boolean;

  @Expose()
  public isDefaultAvl: boolean;

  @Expose()
  public objects: SnCollection<SnLayerObject>;

  @Expose()
  public allowNotification?: boolean;

  @Expose()
  public integrationType?: string;

  @Expose()
  public integrationTypeCode?: string;

  @Expose()
  @Exclude({ toPlainOnly: true })
  public isShared: boolean;

  @Expose()
  public isOwned: boolean;

  @Expose()
  @Type(() => SnLayerMeta)
  public meta: SnLayerMeta;

  @Expose()
  @Exclude({ toPlainOnly: true })
  @Type(() => SnShareInfo)
  public shareInfo: SnShareInfo;

  @Expose()
  @Exclude({ toPlainOnly: true })
  @Type(() => SnOrganization)
  public organization: SnOrganization;

  public hits: SnLayerHit[];

  constructor(data: any = {}) {
    super();
    this.fromJSON(data);
  }
}
